/* Excella — open the theme's Quick Buy from a native collection card by relaying the click
   to the original (hidden) .quick-shop element the theme already bound.

   MOBILE (v2): the theme binds .quick-shop ONLY when $(window).width() > 767 (desktop), inside
   a document.ready handler in timber.js. On phones there is no Quick Buy handler, so relaying +
   preventDefault() produced a DEAD button. Fix: on mobile we do NOT intercept — we let the click
   fall through to the card's own <a href> (the product page URL), where the shopper selects the
   variant and adds to cart (product-page add-to-cart works via excella-product-atc.js). Desktop
   behaviour is unchanged. */
(function(){
  'use strict';
  document.addEventListener('click', function(e){
    var a = e.target.closest ? e.target.closest('.exc-qb-open') : null;
    if(!a) return;
    if (window.innerWidth <= 767) return; /* mobile: follow the href to the product page */
    var dh = a.getAttribute('data-href');
    if(!dh) return;
    var orig = document.querySelector('.exc-qb-hidden a.quick-shop[data-href="'+dh+'"]')
            || document.querySelector('a.quick-shop[data-href="'+dh+'"]');
    if(orig){ e.preventDefault(); orig.click(); }
    /* if not found, let the link fall through to the product page */
  }, false);
})();
